export default __webpack_public_path__ + "images/HN.5d96df9.png";